<script setup>
import { clearError } from 'nuxt/app'
const props = defineProps({
  error: Object
})
</script>

<template>
  <Head>
    <Title>Lyber - Errore</Title>
  </Head>
  <NuxtLayout name="default" :is-article="true">
    <main>
      <div class="px-4 sm:px-0 w-full sm:w-11/12 lg:w-5/6 xl:w-3/4 mx-auto py-28">
        <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center" v-if="parseInt(error.statusCode) === 404">
          <img class="hidden lg:block lg:order-2 lg:max-w-[450px] xl:max-w-[570px] 2xl:max-w-[763px]" src="@/assets/images/404_desktop.jpg" srcset="@/assets/images/404_desktop.jpg 2x" alt="" width="763" height="668">
          <img class="block lg:hidden" src="@/assets/images/404_mobile.jpg" srcset="@/assets/images/404_mobile.jpg 2x" alt="" width="768" height="675">
          <div class="text-center lg:text-left lg:order-1 ">
            <h1 class="font-family-raleway font-bold text-[56px] lg:text-[73px]">Tuuu tuu...</h1>
            <p class="text-[18px] lg:text-[20px]">Attenzione la pagina da lei cercata &egrave; inesistente.</p>
            <p class="text-[18px] lg:text-[20px]">La invitiamo a riprovare da un'altra parte.</p>
            <div class="mb-32 mt-10 lg:mb-0 lg:mt-12">
              <button class="text-white bg-mnet px-4 py-2 border border-mnet font-semibold text-base lg:text-lg hover:bg-white hover:text-mnet rounded-3xl"
                @click="() => clearError({redirect: '/blog/'})"
              >TORNA ALLA HOME
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          {{ error.message }}
        </div>
      </div>
    </main>
  </NuxtLayout>
</template>